import { useEffect } from "react";
import { useAppSetting, getBrandingUrl } from "@/hooks/useAppSettings";
import { AMBIENTE_BETA } from "@/lib/ambiente";

const ligarLink = (rel: string, href: string, seletor = `link[rel='${rel}']`) => {
  let link = document.querySelector<HTMLLinkElement>(seletor);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
};

/**
 * Título da aba, favicon e ícones do app.
 *
 * Em produção vêm de app_settings (favicon e app_icon). No beta, tudo é fixo
 * e carimbado: "BETA - Glucofy" na aba, ícone com BETA em vermelho e um
 * manifest próprio, para o app instalado no celular também se chamar BETA.
 * Render once at the app root level.
 */
const DynamicHead = () => {
  const { data: faviconPath } = useAppSetting("favicon");
  const { data: appIconPath } = useAppSetting("app_icon");

  useEffect(() => {
    if (!AMBIENTE_BETA) return;
    document.title = "BETA - Glucofy";
    ligarLink("icon", "/favicon-beta.png");
    ligarLink("apple-touch-icon", "/app-icon-beta.png", "link[rel='apple-touch-icon']:not([sizes])");
    document.querySelectorAll<HTMLLinkElement>("link[rel='apple-touch-icon'][sizes]").forEach((l) => { l.href = "/app-icon-beta.png"; });
    ligarLink("manifest", "/manifest-beta.webmanifest");
  }, []);

  useEffect(() => {
    if (AMBIENTE_BETA) return;
    // getBrandingUrl already appends ?v= cache-buster — use as-is to avoid double query string
    const faviconUrl = getBrandingUrl(faviconPath);
    if (faviconUrl) ligarLink("icon", faviconUrl);
  }, [faviconPath]);

  useEffect(() => {
    if (AMBIENTE_BETA) return;
    // getBrandingUrl already appends ?v= cache-buster — use as-is to avoid double query string
    const iconUrl = getBrandingUrl(appIconPath);
    if (iconUrl) {
      // Update the primary apple-touch-icon (no sizes attribute)
      const appleLink = document.querySelector<HTMLLinkElement>("link[rel='apple-touch-icon']:not([sizes])");
      if (appleLink) appleLink.href = iconUrl;
    }
  }, [appIconPath]);

  return null;
};

export default DynamicHead;
